<template>

    <div class="border border-keyline-primary mt-6 p-8 rounded w-full" role="alert" v-if="form.errors.length">
        <ul class="font-medium mx-auto text-left text-red w-fit">
            <li v-for="error in form.errors">
                {{error}}
            </li>
        </ul>
    </div>

    <form class="mt-6 w-full" v-if="!submitted">
        <fieldset class="gap-[30px] grid mb-12 at768:grid-cols-2">
            <SeclockInput
                v-model="form.name"
                type="text"
                required
                label="Full Name"
                class="dark:!bg-white dark:!border-gray-300 dark:!text-gray-800"
                :animated="true"
                :error="form.errors.name"
                @invalid="invalidate"
            />
            <SeclockInput
                v-model="form.company"
                type="text"
                required
                label="Company"
                class="dark:!bg-white dark:!border-gray-300 dark:!text-gray-800"
                :animated="true"
                :error="form.errors.company"
                @invalid="invalidate"
            />
            <SeclockInput
                v-model="form.email"
                type="email"
                required
                label="Email"
                class="dark:!bg-white dark:!border-gray-300 dark:!text-gray-800"
                :animated="true"
                :error="form.errors.email"
                @invalid="invalidate"
            />
            <SeclockInput
                v-model="form.phone"
                type="tel"
                required
                label="Phone"
                minlength="10"
                maxlength="17"
                class="dark:!bg-white dark:!border-gray-300 dark:!text-gray-800"
                :animated="true"
                :error="form.errors.phone"
                @invalid="invalidate"
            />
        </fieldset>

        <button
            @click.stop.prevent="submit"
            :disabled="form.processing"
            class="btn-white-on-red justify-center w-full"
        >
            Submit
            <BaseSvg name="ArrowForward" class="ml-2" aria-hidden="true"/>
        </button>
    </form>
    <div class="border border-keyline-primary mt-6 p-8 rounded w-full" role="alert" v-else>
        <p class="font-medium">Thank you for your request, we will be in touch shortly.</p>
    </div>
</template>
<script setup>
import { SeclockInput } from "@/Components";
import { ref } from "vue";
import { useForm } from "@inertiajs/vue3";
import { eventBus } from "@/Composables";

const errors = ref(false);
const submitted = ref(false);

const invalidate = () => {
    errors.value = true;
};

const form = useForm({
    name: null,
    email: null,
    phone: null,
    company: null,
    form_name: "accountrepmeeting",
});

const submit = () =>
    form.post(route("web.sendgrid"), {
        preserveScroll: true,
        onSuccess: () => {
            form.reset();
            submitted.value = true;
        },
        onError: () => {
            console.log(form.errors);
            eventBus.emit("alert:show", {
                title: "Error",
                message: "There was a problem submitting the form",
                level: "danger",
            });
        },
    });
</script>
